import { render, staticRenderFns } from "./GroupAdmin.vue?vue&type=template&id=4aefd3fb&"
import script from "./GroupAdmin.vue?vue&type=script&lang=js&"
export * from "./GroupAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports